export default {
  path: 'fuel-probe',
  name: 'FuelProbe',
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/FuelProbeIndexView.vue')
}
